class PiLaunchBanner extends HTMLElement {
  constructor() {
    super();
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  connectedCallback() {
    this.access = this.querySelector('[data-pi-launch-access]');
    this.closeButton = this.querySelector('[data-pi-launch-close]');
    if (!this.access) return;

    this.access.addEventListener('toggle', this.onToggle);
    this.closeButton?.addEventListener('click', this.onClose);
    document.addEventListener('click', this.onDocumentClick);

    if (this.querySelector('[data-pi-launch-error]')) {
      this.access.open = true;
    }
  }

  disconnectedCallback() {
    this.access?.removeEventListener('toggle', this.onToggle);
    this.closeButton?.removeEventListener('click', this.onClose);
    document.removeEventListener('click', this.onDocumentClick);
  }

  onToggle() {
    if (!this.access?.open) return;
    this.access.querySelector('input[type="password"]')?.focus();
  }

  onClose() {
    if (!this.access) return;
    this.access.open = false;
    this.access.querySelector('.pi-launch-banner__gate')?.focus();
  }

  onDocumentClick(event) {
    if (!this.access?.open) return;
    if (this.access.contains(event.target)) return;
    this.access.open = false;
  }
}

if (!customElements.get('pi-launch-banner')) {
  customElements.define('pi-launch-banner', PiLaunchBanner);
}
